import React from 'react';
import classes from './Drop.module.scss';
import Images from './Images';
import InnerDocumentText from './InnerDocumentText';
import AnalyticsDiv from '../../AnalyticsDiv';

const Drop = ({
  onDragOver,
  onDrop,
  openFileDialog,
  disabled,
  fileInputRef,
  onFilesAdded,
  delay,
  tagAdd,
  idSubir,
}) => (
  <AnalyticsDiv
    className={classes.Dropzone}
    onDragOver={onDragOver}
    id={`dropzone-sub-container-${idSubir}`}
    onDrop={onDrop}
    onClick={openFileDialog}
    style={{
      cursor: disabled ? 'default' : 'pointer',
    }}
    tag={tagAdd}
  >
    <input
      ref={fileInputRef}
      className={classes.FileInput}
      type="file"
      id={`dropzone-input-files-${idSubir}`}
      multiple
      onChange={onFilesAdded}
    />
    <div>
      <Images className={classes.containImg} />
      <InnerDocumentText className={classes.textContainer} delay={delay} />
    </div>
  </AnalyticsDiv>
);

export default Drop;
